<template>
  <!-- 字典管理页面 -->
  <div class="main-content" v-loading="loading">
    <!-- 标题 -->
    <!-- <div class="text_title left">字典管理</div> -->
    <!-- 字典搜索栏 -->
    <search-box :searchList="searchList" @search="searchDictionary" @add="addDictionary('ruleForm')" @del="deleteDictionaries" @reset="resetSearch" :selectIds="selectIds"/>
    <!-- 操作按钮弹框 -->
    <ButtonDialog ref="buttonDialog" :modelValue="dialogFormVisible" :dialogTitle="dialogTitle" :dialogWidth="dialogWidth" @update:modelValue="dialogFormVisible = $event" @confirm="submitForm('ruleForm')">
      <slot>
        <el-form label-position="right" label-width="80px" :model="formLabelAlign" :rules="rules" ref="ruleForm">
          <el-form-item label="字典名称" prop="dictName">
            <el-input v-model="formLabelAlign.dictName" placeholder="请输入字典名称" clearable></el-input>
          </el-form-item>
          <el-form-item label="字典编码" prop="dictCode">
            <el-input v-model="formLabelAlign.dictCode" :disabled="dialogTitle === '编辑字典'" placeholder="请输入字典编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status" >
            <el-select v-model="formLabelAlign.status" style="width: 100%;">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字典描述" prop="description">
            <el-input type="textarea" :rows="2" v-model="formLabelAlign.description" placeholder="请输入字典描述"  maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </slot>
    </ButtonDialog>
    <!-- 字典总表+分页器 -->
    <dictionary-table id="table" ref="table" :tableList="tableList" :table-data="tableData" @handleEdit="handleEdit" @handleDelete="handleDelete" @handleList="handleList"  :total="total" :page-size="size" :currentPage="page" @handleSelect="handleSelect" @pagechange="pageChange" @sizeChange="sizeChange" @select="handleSelect" />
  </div>
</template>

<script>
import SearchBox from '@/components/table/SearchBox.vue'
import { dictionaryManageList } from '@/data/tableList'
import { getDictionary, deleteDictionary, addDictionary, updateDictionary, getItemDictionary } from '@/api/dictionary/dictionary'
import DictionaryTable from '@/tables/DictionaryTable.vue'
import ButtonDialog from '@/components/dialog/ButtonDialog.vue'

export default {
  name: 'DictionaryManageView',
  components: {
    SearchBox,
    DictionaryTable,
    ButtonDialog
  },
  data () {
    return {
      // 表头列表
      tableList: dictionaryManageList,
      // 搜索栏列表
      searchList: dictionaryManageList,
      // 字典列表数据
      tableData: [],
      // 选中的字典 id
      selectIds: [],
      // 每页显示的数量
      size: 10,
      // 当前页码
      page: 1,
      // 总数量
      total: 0,
      // 字典弹窗是否显示
      dialogFormVisible: false,
      // 字典弹窗标题
      dialogTitle: '',
      // 字典弹窗宽度
      dialogWidth: '30%',
      formLabelAlign: {
        id: '',
        dictName: '',
        dictCode: '',
        status: true,
        description: ''
      },
      rules: {
        dictName: [
          { required: true, message: '请输入字典名称', trigger: 'blur' }
        ],
        dictCode: [
          { required: true, message: '请输入字典编码', trigger: 'blur' }
        ]
      },
      options: [
        { value: true, label: '启用' },
        { value: false, label: '禁用' }
      ],
      loading: false
    }
  },
  mounted () {
    // 获取字典列表
    this.getDictionaryList()
    // 字典下拉框赋值
    this.$assignDictOptions(this.searchList, { status: 'dictionary_status' }, this.selectDictionary)
  },
  computed: {
    selectDictionary () {
      return this.$store.getters.getDictionaryList
    }
  },
  methods: {
    // 获取字典列表
    async getDictionaryList () {
      this.loading = true
      try {
        const res = await getDictionary({ page: this.page, size: this.size })
        if (res.code === 200) {
          this.tableData = res.data.records
          this.total = res.data.total
        }
        this.loading = false
      } catch (error) {
        console.error(error)
      } finally{
        this.loading = false
      }
    },
    resetSearch () {
      this.page = 1
      this.getDictionaryList()
    },
    // 选择字典
    handleSelect (selection) {
      this.selectIds = selection.map(item => item.id)
    },
    // 分页器
    pageChange (val) {
      this.page = val
      this.getDictionaryList()
    },
    // 页码大小改变
    sizeChange (val) {
      this.size = val
      this.getDictionaryList()
    },
    // 表格操作栏按钮 - 编辑
    async handleEdit (rawObject) {
      this.dialogTitle = '编辑字典'
      // 创建深拷贝对象，避免直接引用表格数据
      const copyData = JSON.parse(JSON.stringify(rawObject))

      // 状态转换（根据显示文本转换为布尔值）
      copyData.status = copyData.statusName === '启用'

      // 使用拷贝后的数据
      this.formLabelAlign = copyData
      this.dialogFormVisible = true
    },
    // 操作栏按钮 - 单个删除
    handleDelete (rawObject) {
      this.$msgbox({
        title: '提示',
        message: '是否删除该字典?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async () => {
        const res = await getItemDictionary({ dictCode: rawObject.dictCode })
        if (res.code === 200) {
          const itemList = res.data.records
          if (itemList.length > 0) {
            this.$msgbox({
              title: '提示',
              message: '该字典已被使用，请先删除字典项',
              type: 'warning',
              showCancelButton: false,
              confirmButtonText: '确定'
            })
          } else {
            const res = await deleteDictionary(rawObject.id)
            if (res.code === 200) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.getDictionaryList()
            } else {
              this.$message({
                message: '删除失败',
                type: 'error'
              })
            }
          }
        }
      }).catch(() => {})
    },
    handleList (val) {
      this.$router.push({ path: '/dictionary/data', query: { dictCode: val.dictCode, dictId: val.id } })
    },
    // 批量删除
    async deleteDictionaries (val) {
      const success = await this.$deleteHandler(deleteDictionary, this.selectIds, '字典', val)
      if (success) {
        this.selectIds = []
        this.getDictionaryList()
      }
    },
    // 搜索字典
    async searchDictionary (searchData) {
      this.loading = true
      this.tableData = []
      this.page = 1
      try {
        const data = { page: this.page, size: this.size }
        const apiParams = { ...searchData, updateTime: undefined }
        const resData = await this.$searchHandler(getDictionary, apiParams, data)
        if (resData.code === 200) {
          this.tableData = resData.data.records
          this.total = resData.data.total
              this.$message({
                message: resData.msg,
                type: 'success'
              })
          this.loading = false
        }
      } catch (error) {
        console.error(error)
      } finally{
        this.loading = false
      }
    },
    // 新增字典
    addDictionary (formName) {
      this.formLabelAlign = { status: true }
      this.dialogTitle = '新增字典'
      this.dialogFormVisible = true
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const submitData = { ...this.formLabelAlign }
          submitData.status = submitData.status ? 1 : 0

          const operation = this.dialogTitle === '新增字典'
            ? addDictionary
            : updateDictionary

          const res = await operation(submitData)
          if (res.code === 200) {
            this.dialogFormVisible = false
            // 重置表单
            this.$refs[formName].resetFields()
            this.$message.success('操作成功')
            this.getDictionaryList()
          } else {
            this.$message.error('操作失败')
          }
        } else {
          console.error('表单验证失败')
          return false
        }
      })
    }
  }
}
</script>

<style>
</style>
